var _circle, _circle2, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 74.5,
    r: 74.5,
    fill: "#d92b2b",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 74.5,
    r: 58.752,
    fill: "#d92b2b",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    x: 32.5,
    y: 33,
    fill: "#d92b2b",
    rx: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.864,
    d: "M74.5 66.887v10.022m17.335-8.438V81.53a6.06 6.06 0 0 1-2.998 5.212l-11.34 6.548a6.04 6.04 0 0 1-6.013 0l-11.34-6.548a6.01 6.01 0 0 1-2.998-5.212V68.471a6.06 6.06 0 0 1 2.998-5.212l11.34-6.548a6.04 6.04 0 0 1 6.013 0l11.34 6.548a6.04 6.04 0 0 1 2.998 5.212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.818,
    d: "M74.5 83.019v.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycError);
export default __webpack_public_path__ + "static/media/kycError.2e22a13db9b2a3e0b424e6db6fc28101.svg";
export { ForwardRef as ReactComponent };